import { ELineType } from 'shared/repositories/offer-card/entities/geo/UndergroundInfoSchema';
import {
  IOfferSchema,
  IAddressInfoSchema,
  IUndergroundInfoSchema,
} from 'shared/types/api-models/offer-card/v1/get-offer-data';

/** Маппинг ELineType на буквенное обозначение линии */
const LINE_TYPE_TO_DISPLAY: Record<ELineType, string> = {
  [ELineType.Mcd1]: 'МЦД-1',
  [ELineType.Mcd2]: 'МЦД-2',
  [ELineType.Mcd3]: 'МЦД-3',
  [ELineType.Mcd4]: 'МЦД-4',
  [ELineType.Mck]: 'МЦК',
};

const getUndergroundName = (underground: IUndergroundInfoSchema | undefined): string | void => {
  if (!underground || !underground.name) {
    return undefined;
  }

  const lineType = underground.lineType ? LINE_TYPE_TO_DISPLAY[underground.lineType] : null;

  return lineType ? `${lineType} ${underground.name}` : `м. ${underground.name}`;
};

export const getGeoLabel = (offer: IOfferSchema) => {
  const { geo } = offer;

  if (!geo) {
    return '';
  }

  let address: IAddressInfoSchema[] = [...(geo.address || [])];
  const street = address.find(({ type }) => type === 'street');

  if (street) {
    const house = address.find(({ type }) => type === 'house');
    const city = address.find(({ locationTypeId }) => locationTypeId === 1);
    const head = [street, house, city].filter(Boolean) as IAddressInfoSchema[];

    address = [...head, ...address.filter(item => !head.includes(item))];
  }

  const underground = (geo.undergrounds || [])[0];

  return [
    address
      .map(({ shortName }) => shortName)
      .filter(Boolean)
      .join(', '),
    getUndergroundName(underground),
  ]
    .filter(Boolean)
    .join(' ');
};
